module.exports = __webpack_public_path__ + "static/media/bruker_light.62f568fd.png";